import { defineFetch } from 'resift';
import { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';

export default defineFetch({
  displayName: 'Get User Fields',
  make: () => ({
    key: [],
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/fields`,
        query: {
          returnDisabledFields: true,
          expand: 'userEditability',
          entityTypeKey: PERSON_ENTITY_TYPE_KEY,
        },
      }),
  }),
});
